var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewTab = function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#089BEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.657v4.5a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H9m-1.8 7.8l4.5-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95 6.957h3.75v3.75"
  }))));
};
export default SvgNewTab;